import { render, staticRenderFns } from "./HeaderStyleAlumno.vue?vue&type=template&id=0fc15f5b&"
import script from "./HeaderStyleAlumno.vue?vue&type=script&lang=js&"
export * from "./HeaderStyleAlumno.vue?vue&type=script&lang=js&"
import style0 from "./HeaderStyleAlumno.vue?vue&type=style&index=0&id=0fc15f5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports